import { createSelector } from 'reselect'

const getCartDiff = state => state.entities.cartDiff

export const getItemList = createSelector([getCartDiff], cartDiffData =>
  cartDiffData.get('itemList', null).toJS()
)
